/**
 * @generated SignedSource<<98e75ef865b9feab12077800387891f6>>
 * @relayHash c542d13d0a5bd0aa600652070fdd90f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 759f3e60085bb6145df9935769c46fb69f7228fd0e430876b2646cfb9ef1df11

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { IssueTransitionModalQuery } from './IssueTransitionModalQuery.graphql';

import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';

const node: PreloadableConcreteRequest<IssueTransitionModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "759f3e60085bb6145df9935769c46fb69f7228fd0e430876b2646cfb9ef1df11",
    "metadata": {},
    "name": "IssueTransitionModalQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider
    }
  }
};

export default node;
